'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _formItem = require('./formItem');

var _formItem2 = _interopRequireDefault(_formItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormComponent(props) {
	var className = (0, _classnames2.default)((0, _defineProperty3.default)({
		'mk-form': true,
		'mk-form-horizontal': props.layout == 'horizontal',
		'mk-form-vertical': props.layout == 'vertical'
	}, props.className, !!props.className));

	return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
		className: className
	}));
}

FormComponent.Item = _formItem2.default;

exports.default = FormComponent;
module.exports = exports['default'];